import React from 'react';
import { CheckCircleIcon, ShieldCheckIcon, AwardIcon, UsersIcon } from 'lucide-react';
export const About = () => {
  return <section id="about" className="py-20 bg-white" data-id="element-26">
      <div className="container mx-auto px-4" data-id="element-27">
        {/* Main intro */}
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-28">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-kgi-blue-900 mb-6" data-id="element-29">
            Licensed. Experienced. Trusted.
          </h2>
          <p className="text-xl text-gray-700 mb-6 leading-relaxed" data-id="element-30">
            Licensed, insured, and trusted across Michigan, Illinois, Indiana,
            and Ohio, Koda Group Inc. provides professional private
            investigation and security services for individuals, businesses, and
            legal professionals.
          </p>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-31">
            Since our founding, we have built a reputation for delivering
            results that matter. Our investigators bring real-world law
            enforcement experience, advanced certifications, and an unwavering
            commitment to uncovering the truth. When you need answers, you need
            professionals who understand the stakes—and deliver evidence that
            stands up in court.
          </p>
        </div>
        {/* Key differentiators */}
        <div className="max-w-6xl mx-auto" data-id="element-32">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-33">
            <div className="bg-kgi-blue-50 rounded-lg p-6 border-t-4 border-kgi-blue" data-id="element-34">
              <ShieldCheckIcon className="h-10 w-10 text-kgi-blue mx-auto mb-3" data-id="element-35" />
              <h3 className="font-bold text-kgi-blue-900 mb-2" data-id="element-36">
                Multi-State Licensed
              </h3>
              <p className="text-sm text-gray-600" data-id="element-37">
                Operating in MI, IL, IN, OH with nationwide consultants
              </p>
            </div>
            <div className="bg-kgi-blue-50 rounded-lg p-6 border-t-4 border-kgi-blue" data-id="element-38">
              <CheckCircleIcon className="h-10 w-10 text-kgi-blue mx-auto mb-3" data-id="element-39" />
              <h3 className="font-bold text-kgi-blue-900 mb-2" data-id="element-40">
                Latest Technology
              </h3>
              <p className="text-sm text-gray-600" data-id="element-41">
                GPS tracking, surveillance systems, electronic monitoring
              </p>
            </div>
            <div className="bg-kgi-blue-50 rounded-lg p-6 border-t-4 border-kgi-blue" data-id="element-42">
              <AwardIcon className="h-10 w-10 text-kgi-blue mx-auto mb-3" data-id="element-43" />
              <h3 className="font-bold text-kgi-blue-900 mb-2" data-id="element-44">
                Certified Experts
              </h3>
              <p className="text-sm text-gray-600" data-id="element-45">
                Certified Criminal Defense & Construction Investigators
              </p>
            </div>
            <div className="bg-kgi-blue-50 rounded-lg p-6 border-t-4 border-kgi-blue" data-id="element-46">
              <UsersIcon className="h-10 w-10 text-kgi-blue mx-auto mb-3" data-id="element-47" />
              <h3 className="font-bold text-kgi-blue-900 mb-2" data-id="element-48">
                Proven Track Record
              </h3>
              <p className="text-sm text-gray-600" data-id="element-49">
                Trusted by attorneys, corporations, and families
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};